import httpClient from './httpClient';
import { LONG_ORCHESTRATOR_REQUEST_MS } from './apiTimeouts';

export interface RoundInfo {
  round_number: number;
  type: 'aptitude' | 'coding' | 'gd';
  config: Record<string, unknown>;
  scheduledDate: string;
  status?: 'pending' | 'inuse' | 'completed' | 'abandoned';
  session_id?: string;
  overall_score?: number | string | null;
}

export interface RoundSession {
  current_round: { round_number: number; status: string };
  session_interaction: Record<string, unknown>;
}

export interface JDExtractedData {
  role_name?: string;
  company_name?: string;
  domain_name?: string;
  skills?: string[];
  responsibilities?: string[];
  qualifications?: string[];
  additional_info?: Record<string, string>;
  confidence_score?: number;
}

export interface UpcomingCustomInterview {
  id: string;
  name: string;
  deadline: string;
  jobDescription: string;
  status: string;
  ownerType: string;
  rounds: RoundInfo[];
  jdProcessingStatus: string | null;
  jdExtractedData?: JDExtractedData | null;
  accepted: boolean;
  round_session: RoundSession | null;
}

export interface UpcomingResponse {
  success: boolean;
  interviews: UpcomingCustomInterview[];
}

export interface AcceptResponse {
  success: boolean;
  round_session: Record<string, unknown>;
}

export interface StartRoundResponse {
  success: boolean;
  round_num: number;
  type: string;
  session_id?: string;
  message?: string;
  max_questions?: number;
  [key: string]: unknown;
}

export const roundsApi = {
  fetchUpcoming: () =>
    httpClient.get<UpcomingResponse>('rounds/upcoming'),

  accept: (customInterviewId: string) =>
    httpClient.post<AcceptResponse>('rounds/accept', {
      custom_interview_id: customInterviewId,
    }),

  startRound: (
    customInterviewId: string,
    roundNum: number,
    token: string,
    language?: string
  ) =>
    httpClient.post<StartRoundResponse>(
      'rounds/start',
      {
        custom_interview_id: customInterviewId,
        round_num: roundNum,
        token,
        ...(language ? { language } : {}),
      },
      { timeout: LONG_ORCHESTRATOR_REQUEST_MS }
    ),

  getStatus: (customInterviewId: string) =>
    httpClient.get<{ success: boolean; round_session: Record<string, unknown> }>(
      `rounds/status?custom_interview_id=${customInterviewId}`
    ),
};
